// extracted by mini-css-extract-plugin
export default {"search":"Search_search__El3Yi","searchItems":"Search_searchItems__4c70r","inp":"Search_inp__gDGrE","btn":"Search_btn__UF-oP"};